/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum CcbSwitchName {
    ENABLE_DEVELOPER_SANDBOX,
    ENABLE_FILTERED_GUIDE,
    ENABLE_INCLUDE_ADULT,
    ENABLE_ONELINE_GUIDE,
    ENABLE_PARENTAL_CONTROLS,
    ENABLE_SUBSCRIBED_CHANNELS,
}
